import { DirtyFormService } from "~app/common/services/dirty-form.service";
export abstract class DirtyTabComponent {
    constructor(private readonly dirtyFormService: DirtyFormService) {
    }
    abstract restoreChanges();
    abstract canSave();
    abstract isDirtyCheck(): boolean;
    abstract saveChanges();

    canDeactivate = (): Promise<boolean> => new Promise(resolve => {
        if (this.isDirtyCheck()) {
            const saveFn = this.canSave() ? (async () => {
                await this.saveChanges();
                resolve(true);
            }) : null;
            return this.dirtyFormService.dirtyFormModal(async () => {
                await this.restoreChanges();
                resolve(true);
            }, saveFn, (arg) => {
                resolve(false);
            });
        } else {
            resolve(true);
            return undefined;
        }
    });
}
